import { UseQueryOptions, useQuery } from '@tanstack/react-query';
import { PageResponse } from '@models/api';

import { PartnerProductPriceBulkUploadDetailResponse } from '../../models/partnerBulk';
import {
  GetPriceUploadHistoryDetailsParams,
  getPriceUploadHistoryDetails,
} from '../../apis/partnerBulk';
import { isValidPositiveNumber } from './priceUploadQueryUtils';

export const usePriceUploadDetails = ({
  partnerId,
  page,
  pageSize,
  uploadId,
  params,
}: {
  partnerId: number;
  page: number;
  pageSize: number;
  uploadId: number;
  params: GetPriceUploadHistoryDetailsParams;
}) => {
  const onlyFailed = Boolean(params.onlyFailed);
  const filterParams: GetPriceUploadHistoryDetailsParams = onlyFailed
    ? { onlyFailed: true }
    : {};

  const queryOptions: UseQueryOptions<
    PageResponse<PartnerProductPriceBulkUploadDetailResponse>,
    Error
  > = {
    queryKey: [
      'uploadPartnerHistoryDetails',
      partnerId,
      uploadId,
      page,
      pageSize,
      { onlyFailed },
    ],
    enabled:
      isValidPositiveNumber(partnerId) &&
      isValidPositiveNumber(uploadId) &&
      isValidPositiveNumber(page) &&
      isValidPositiveNumber(pageSize),
    queryFn: () => {
      return getPriceUploadHistoryDetails(partnerId, uploadId, {
        pageNo: page,
        pageSize,
        ...filterParams,
      });
    },
  };
  return useQuery(queryOptions);
};
